import { render, staticRenderFns } from "./saveOrUpdateSysExamRoom.vue?vue&type=template&id=2156b287&scoped=true&"
import script from "./saveOrUpdateSysExamRoom.vue?vue&type=script&lang=js&"
export * from "./saveOrUpdateSysExamRoom.vue?vue&type=script&lang=js&"
import style0 from "./saveOrUpdateSysExamRoom.vue?vue&type=style&index=0&id=2156b287&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2156b287",
  null
  
)

export default component.exports